var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { get } from "lodash";
import linkedCardService from "@irati/perksgo/services/linkedcards";
import authentication from "@irati/auth";
import { hangPromise } from "@irati/utils/promise";
import Loading from "@irati/ui/src/Loading";
import Card from "@irati/ui/src/Layout/Card";
import { Label2, Caption } from "@irati/ui/src/Labels";
import { greys } from "@irati/ui/src/global/colors";
import { connect } from "@irati/store";
import id from "@irati/utils/id";
import { ButtonRouterLink } from "@irati/ui/src/Link";
import { minWidthMedia } from "@irati/ui/src/global/media";
import Icon from "@irati/ui/src/Icon";
import { FormattedMessage, LangLoader } from "@irati/utils/lang";
import { PERKSGO } from "@irati-web/app/src/routeConfig";
var FlexCard = styled(Card)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  margin-top: 20px;\n\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  margin-top: 20px;\n\n  ",
    "\n"])), minWidthMedia.tablet(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    flex-direction: row;\n    margin-top: 30px;\n  "], ["\n    flex-direction: row;\n    margin-top: 30px;\n  "]))));
var StyledButton = styled(ButtonRouterLink)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), minWidthMedia.tablet(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: 200px;\n  "], ["\n    width: 200px;\n  "]))));
var TextWrapper = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var PerksGOImage = styled(Icon)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  width: 40px;\n  height: 25px;\n  margin-right: 15px;\n\n  ", "\n"], ["\n  width: 40px;\n  height: 25px;\n  margin-right: 15px;\n\n  ",
    "\n"])), minWidthMedia.tablet(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    width: 70px;\n    height: 46px;\n  "], ["\n    width: 70px;\n    height: 46px;\n  "]))));
var Desc = styled(Caption).attrs({
    flush: true
})(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), greys.mediumDark);
var TextImageWrapper = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var ButtonWrapper = styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  flex-grow: 1;\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n  margin-top: 20px;\n\n  ", "\n"], ["\n  flex-grow: 1;\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n  margin-top: 20px;\n\n  ",
    "\n"])), minWidthMedia.tablet(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    margin-top: 0;\n    width: auto;\n  "], ["\n    margin-top: 0;\n    width: auto;\n  "]))));
var WalletBanner = /** @class */ (function (_super) {
    __extends(WalletBanner, _super);
    function WalletBanner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            load: hangPromise(),
            linkedCardsCount: undefined
        };
        _this.componentDidMount = function () {
            _this.setState({ load: _this.hasLinkedCards() });
        };
        _this.hasLinkedCards = function () {
            var userId = authentication.user().uuid;
            return linkedCardService.getPerksGOCards({ userId: userId }).then(function (linkedCards) {
                _this.setState({ linkedCardsCount: linkedCards.length });
            });
        };
        return _this;
    }
    WalletBanner.prototype.render = function () {
        var isMobile = this.props.isMobile;
        var linkedCardsCount = this.state.linkedCardsCount;
        var apps = this.context.apps;
        var idNamespace = id("perks-go-banner", this.props);
        return (React.createElement(LangLoader, { bucket: PERKSGO },
            React.createElement(Loading, { load: this.state.load }, linkedCardsCount > 0 && (React.createElement(FlexCard, { id: idNamespace },
                React.createElement(TextImageWrapper, null,
                    React.createElement(PerksGOImage, { icon: "perksGO", size: isMobile ? 40 : 70 }),
                    React.createElement(TextWrapper, null,
                        React.createElement(Label2, { bold: true },
                            React.createElement(FormattedMessage, { id: "perksgo.walletBanner.title", values: { cardsCount: linkedCardsCount } })),
                        !isMobile && (React.createElement(Desc, null,
                            React.createElement(FormattedMessage, { id: "perksgo.walletBanner.description" }))))),
                React.createElement(ButtonWrapper, null,
                    React.createElement(StyledButton, { id: id("manage-linked-cards-button", idNamespace), full: true, app: apps.ACCOUNT, to: "/settings/linkedcards" },
                        React.createElement(FormattedMessage, { id: "perksgo.walletBanner.button.text" }))))))));
    };
    WalletBanner.contextTypes = {
        apps: PropTypes.object.isRequired
    };
    return WalletBanner;
}(Component));
var mapStateToProps = function (_a) {
    var mq = _a.mq;
    return ({
        isMobile: get(mq, "lessThan.medium", false)
    });
};
export default connect(mapStateToProps, {})(WalletBanner);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
